<template>
  <v-card class="mb-6 px-3 mt-3">
    <v-row>
      <v-col cols="12" sm="6" md="4">
        <v-text-field
          disabled
          label="ФИО"
          required
          v-model="user.title"
          @change="updateUser({ title })"
        ></v-text-field>
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";

export default {
  data() {
    return {
      // regionId: null,
      name: null,
    };
  },
  computed: {
    ...mapGetters(["user"]),
  },
  watch: {},
  methods: {},
  mutations: {
    ...mapMutations(["updateUser"]),
  },
};
</script>

<style lang="scss" scoped>
.default-img {
  filter: grayscale;
}
</style>
